/* eslint-disable @next/next/no-img-element, react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { isMobile } from 'react-device-detect';
import { PAYPAL_MESSAGING } from '../brands/default/content/components/paypalMessaging';
import {
  IS_PAYPAL_MESSAGING_ENABLED,
  PAYPAL_CREDIT_ENABLED,
} from '../brands/default/features';
import { PAYPAL_CREDIT_LINK } from '../brands/default/links';
import { PAYPAL_CREDIT } from '../config/constants/images';
import { getIsLeadGen } from '../helpers/deals';
import ThemeContext from '../providers/ThemeProvider';

const PayPalMessaging = ({
  deal,
  isFeatured,
  isFeaturedSlot,
  isMarketingCreditDeal,
  isOnBasket = false,
  isPayPalDeal = false,
}) => {
  const theme = useContext(ThemeContext);
  const size = isMobile ? '13' : '15';
  const isLeadGen = getIsLeadGen(deal);
  const showPayCredit = deal.price >= 190 && deal.price <= 2_000;

  if (IS_PAYPAL_MESSAGING_ENABLED || !isPayPalDeal || isLeadGen) {
    return null;
  }
  // don't show for gambling sub cats
  const noShowSubCats = [218, 711];
  if (
    (deal?.subCategory && noShowSubCats.includes(deal?.subCategory?.id)) ||
    deal.highFraudRisk
  ) {
    return null;
  }

  return (
    <>
      {showPayCredit && PAYPAL_CREDIT_ENABLED ? (
        <div
          className={classNames('paypal', {
            'paypal--featured': isFeaturedSlot,
            'paypal--featured-slot': isFeatured,
          })}
        >
          {!isOnBasket && (
            <img
              alt={PAYPAL_MESSAGING.paypalCreditAlt}
              className="paypal__img"
              height="34"
              loading="lazy"
              src={PAYPAL_CREDIT}
              width="100"
            />
          )}
          <div className="paypal__text">
            {isOnBasket && (
              <span
                dangerouslySetInnerHTML={{
                  __html: PAYPAL_MESSAGING.paypalCreditLegalCheckout,
                }}
              />
            )}
            {isOnBasket && (
              <img
                alt={PAYPAL_MESSAGING.paypalCreditAlt}
                className="paypal__img"
                height="20"
                loading="lazy"
                src={PAYPAL_CREDIT}
                width="60"
              />
            )}
            <span>{PAYPAL_MESSAGING.paypalCreditText}</span>
            {isOnBasket && (
              <div
                dangerouslySetInnerHTML={{
                  __html: PAYPAL_MESSAGING.paypalCreditRepresentativeText,
                }}
              />
            )}
            <a
              className="paypal__link"
              href={PAYPAL_CREDIT_LINK}
              rel="noreferrer noopener"
              target="_blank"
            >
              {' '}
              {PAYPAL_MESSAGING.paypalCreditLinkText}
            </a>
          </div>
        </div>
      ) : (
        <div
          data-pp-amount={isMarketingCreditDeal ? deal.vipPrice : deal.price}
          data-pp-message
          data-pp-style-text-size={size}
          data-qa="paylater-container"
          data-testid="paylater-container"
        />
      )}

      <style jsx>{`
        .paypal {
          display: flex;
        }
        .paypal--featured-slot {
          flex-direction: column;
          padding: 8px;
        }
        .paypal:not(.paypal--featured-slot) {
          flex-direction: row;
          align-items: center;
          margin-bottom: 10px;
        }
        .paypal:not(.paypal--featured-slot) .paypal__img {
          margin-right: 20px;
          margin-bottom: 0;
        }
        .paypal__img {
          max-width: 100px;
          margin-bottom: 8px;
          margin-right: 8px;
        }
        .paypal__text {
          color: #888888;
          margin: 0;
        }
        .paypal__link {
          color: ${theme.colors.primary};
        }
        @media (max-width: ${theme.breakpoints.mdDown}) {
          .paypal {
            display: flex !important;
            flex-direction: row;
            align-items: center;
          }
          .paypal__img {
            margin-right: 20px;
            margin-bottom: 0;
          }
        }
        :global(.main-deal-travel .paypal--featured-slot) {
          flex-direction: row;
        }
        :global(.main-deal-travel .paypal--featured-slot p) {
          padding-left: 10px;
        }
      `}</style>
    </>
  );
};

PayPalMessaging.propTypes = {
  deal: PropTypes.object,
  isFeatured: PropTypes.bool,
  isFeaturedSlot: PropTypes.bool,
  isMarketingCreditDeal: PropTypes.bool,
  isOnBasket: PropTypes.bool,
  isPayPalDeal: PropTypes.bool,
};

PayPalMessaging.defaultProps = {
  deal: {},
  isFeatured: false,
  isFeaturedSlot: false,
  isMarketingCreditDeal: false,
  isOnBasket: false,
  isPayPalDeal: false,
};

export default PayPalMessaging;
